import PropTypes from 'prop-types';
// libraries
import { Box, Button, Container } from '@mui/material';
// components
import { useSettingsContext } from 'src/components/settings/context';
import RescheduleAppointment from '../RescheduleAppointment';
// style
import { leadFooterButtonsStyle, footerBoxStyle, btnStyle } from '../../styles/ScheduleReminder';

const ReScheduleAppointmentPopup = ({ inputRef, handleClose, treatmentData, appoinmentID, appoinmentSelectData, pastAppointment, leadDetail }) => {
    const settings = useSettingsContext();

    const handleNext = async () => {
        await inputRef.current.submit();
    };

    return (
        <Box>
            <RescheduleAppointment ref={inputRef} handleClose={handleClose} type={'RescheduleReminder'} treatmentData={treatmentData} appoinmentID={appoinmentID} appoinmentSelectData={appoinmentSelectData} pastAppointment={pastAppointment} leadDetail={leadDetail} />
            <Box sx={footerBoxStyle}>
                <Container
                    maxWidth={settings.themeStretch ? false : 'xl'}
                    sx={leadFooterButtonsStyle}
                >
                    <Button
                        color='primary'
                        variant='contained'
                        onClick={handleNext}
                        sx={btnStyle}
                    >
                        Finish
                    </Button>
                </Container>
            </Box>
        </Box>
    );
};

export default ReScheduleAppointmentPopup;

ReScheduleAppointmentPopup.propTypes = {
    inputRef: PropTypes.object,
    handleClose: PropTypes.func,
    treatmentData: PropTypes.object,
    appoinmentID: PropTypes.number,
    appoinmentSelectData: PropTypes.object,
    pastAppointment: PropTypes.object,
    leadDetail: PropTypes.object,
};
